export default __webpack_public_path__ + "static/media/complementos_3.063d8070.jpg";